namespace $.$$ {
	export class $mol_fetch_demo extends $.$mol_fetch_demo {
		
		fetch_data(){
			this.data( $mol_fetch.json( this.url() ) )
		}
		
	}
}
